/**
 * Test-lead flag for the booking page.
 *
 * Studio opens the booking page with `?xa_test=1` so a business can send itself a
 * test lead. The flag is kept in sessionStorage — never localStorage, so a later
 * real visit is never tagged — and the widgets read it back to add `xaTest: true`
 * to every submission (see `addTestLeadAttribute` in @xapp/chat-widget-core, which
 * reads this same key).
 */

export const TEST_LEAD_PARAMETER = "xa_test";

export const TEST_LEAD_STORAGE_KEY = "xa_test";

/**
 * Records whether this page view is a test, and returns the flag. A test must never
 * be counted as Google traffic, so any stored `rwg_token` is cleared as well.
 */
export function captureTestLeadFlag(url: URL): boolean {
    const isTest = url.searchParams.get(TEST_LEAD_PARAMETER) === "1";

    try {
        if (isTest) {
            sessionStorage.setItem(TEST_LEAD_STORAGE_KEY, "1");
            localStorage.removeItem("xa_rwg_token");
        } else {
            sessionStorage.removeItem(TEST_LEAD_STORAGE_KEY);
        }
    } catch {
        // Storage can be blocked by the browser. The flag is best effort.
    }

    return isTest;
}
